/**
 * Rating Thresholds - Single source of truth
 *
 * SYNC: This module is shared between frontend and backend.
 * All threshold values for ocean rating calculations are defined here.
 */

export const THRESHOLDS = {
    // Tide levels (feet MLLW)
    tide: {
        veryLow: 0,
        low: 1.5,
        midHigh: 4,
        high: 5,
        veryHigh: 6
    },
    // Swell period quality (seconds)
    period: {
        excellent: 12,
        good: 10,
        fair: 8
    },
    // Wave height (feet)
    wave: {
        flat: 1,
        large: 8,
        dangerous: 10
    },
    // Skill levels by wave height (feet)
    skill: {
        beginner: 2,
        novice: 4,
        intermediate: 6,
        advanced: 8
    },
    // Water temperature (°F)
    water: {
        cold: 55,
        comfortable: 60
    },
    // Wind speed thresholds (mph)
    wind: {
        light: 5,
        moderate: 10,
        strong: 15,
        dangerous: 20
    },
    // Rating score thresholds
    rating: {
        good: 80,
        fair: 60
    },
    // Beach window timing (minutes)
    beach: {
        nearLowTide: 120,
        upcomingWindow: 180
    },
    // Spot-specific scoring bonuses (capped at 100 total)
    bonus: {
        idealWind: 5,          // Wind matches spot's ideal direction
        idealTide: 5,          // Tide matches spot's ideal (low/mid/high)
        idealSwellRange: 5     // Wave height in spot's ideal range
    },
    // Penalties for spot-specific issues
    spotPenalty: {
        swellOutOfWindow: 15,      // Swell direction outside spot's window
        tooLargeForBeginner: 10,   // Large waves at beginner spot (>4ft)
        tooSmallForAdvanced: 5     // Flat conditions at advanced spot (<2ft)
    }
};
